import React, { useState } from "react";
import {
    CheckboxContainer,
    CheckboxLabelAlt,
    Container,
    FormContainer,
    Section,
    StyledInput,
    TermsField,
} from "./styles";
import { Dialog, DialogActions, DialogContent, TextField } from "@material-ui/core";
import Terms from "../../components/Terms";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ptBR } from "date-fns/locale";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import Button from "../../components/Button";
import { useEffect } from "react";
import EventApi from "../../services/event";
import { config } from "../../config";
import { isValidCPF, isValidPassport } from "../../utils/Functions";
import AddChildren from "./AddChildren";
import MetaPixel from "../../tracking/meta";

const defaultForm = {
    name: "",
    email: "",
    phone: "",
    certificate: 0,
    enable: true,
    vip: false,
    status_id: 4,
    solicitation_approved: true,
    is_guest: false,
    role: "",
    gender: "",
    cpf: "",
    day_1: false,
    day_2: false,
    day_3: false,
    extra_people: [],
};

const SubscribeFullPage = (props) => {
    const eventId = props.match.params.event_id;
    const [personData, setPersonData] = useState(defaultForm);
    const [acceptedTerms, setAcceptedTerms] = useState(true);
    const [open, setOpen] = useState(false);
    const [selectedGenders, setSelectedGenders] = useState([]);
    const [customGender, setCustomGender] = useState("");
    const [formSubmited, setFormSubmited] = useState(false);
    const [eventData, setEventData] = useState(null);
    const [isFull, setIsFull] = useState(false);
    const [isDay1Full, setIsDay1Full] = useState(false);
    const [isDay2Full, setIsDay2Full] = useState(false);
    const [isDay3Full, setIsDay3Full] = useState(false);
    const [children, setChildren] = useState([]);
    const [isAddChildOpen, setIsAddChildOpen] = useState(false);
    const [confirmEmail, setConfirmEmail] = useState("");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenAddChild = () => {
        setIsAddChildOpen(true);
    };

    const handleCloseAddChild = () => {
        setIsAddChildOpen(false);
    };

    function onChange(event) {
        const { value, name } = event.target;
        setPersonData({
            ...personData,
            [name]: value,
        });
    }

    const handleAddChildren = (childName) => {
        if (children.length <= 20) setChildren([...children, childName]);
        else toast.warn("Não é possível adicionar mais");
    };

    const handleRemoveChildren = (childName) => {
        setChildren(children.filter((e) => e !== childName));
    };

    const handleChangeDate = (date) => {
        setPersonData({ ...personData, birth: date });
    };

    const handleCustomGenderChange = (e) => {
        setCustomGender(e.target.value);
    };

    const handleGenderChange = (e) => {
        const { value, checked } = e.target;
        if (checked) {
            setSelectedGenders([...selectedGenders, value]);
        } else {
            setSelectedGenders(selectedGenders.filter((e) => e !== value));
        }
    };

    const handleDaysChange = (e) => {
        const { name, checked } = e.target;
        setPersonData({
            ...personData,
            [name]: checked,
        });
    };

    const validFormFields = () => {
        let isValid = true;
        const errors = [];
        Object.entries(personData).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            if (key === "email") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um endereço de email");
                } else if (value.length < 3) {
                    isValid = false;
                    errors.push("Insira um endereço de email válido");
                } else if (value !== confirmEmail) {
                    isValid = false;
                    errors.push("Os emails são diferentes");
                }
            }
            if (key === "phone") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um numero para contato");
                }
            }
            if (key === "cpf") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira seu CPF ou Passaporte");
                } else if (!isValidCpfOrPassport(value)) {
                    isValid = false;
                    errors.push("Insira um CPF ou Passaporte Válido");
                }
            }
        });
        if (!selectedGenders) {
            isValid = false;
            errors.push("Selecione ao menos uma opção no gênero");
        }
        if (!personData.birth) {
            isValid = false;
            errors.push("Informe a Data de Nascimento");
        }
        if (!personData.day_1 && !personData.day_2 && !personData.day_3) {
            isValid = false;
            errors.push("Selecione ao menos um dia");
        }
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const isValidCpfOrPassport = (doc) => {
        return isValidCPF(doc) || isValidPassport(doc);
    };

    const formatData = () => {
        let selectedGendersArr = selectedGenders.includes("custom")
            ? selectedGenders.filter((e) => e !== "custom")
            : selectedGenders;
        let selectedGendersStr = selectedGendersArr.join(";");
        let personGenders = selectedGendersStr
            ? customGender
                ? selectedGendersStr + `;custom:${customGender}`
                : selectedGendersStr
            : selectedGendersStr;
        return {
            ...personData,
            phone: personData.phone ? personData.phone.match(/\d/g).join("") : null,
            cpf: personData.cpf.match(/\d/g).join(""),
            event_id: parseInt(eventId),
            accepted_terms: acceptedTerms,
            gender: personGenders,
            approved_at: new Date(),
            extra_people: children,
            email: personData.email.toLowerCase(),
        };
    };

    const handleSubscribe = async () => {
        if (!eventId) {
            toast.error("Ocorreu um erro para encontrar o evento.");
            return;
        }

        if (!acceptedTerms) {
            toast.warn("É necessário aceitar os termos de uso de dados e imagens");
            return;
        }

        try {
            if (validFormFields()) {
                const formatedData = formatData();
                const createPersonResult = await EventApi.createPerson({
                    ...formatedData,
                });
                if (createPersonResult && createPersonResult.data) {
                    setFormSubmited(true);
                    toast.success("Inscrição realizada!");
                    window.fbq("track", "CompleteRegistration");
                } else {
                    if (createPersonResult?.response?.data?.message === "Already Used.")
                        toast.error("O CPF ou Passaporte já foi cadastrado para este dia");
                    else if (createPersonResult?.response?.data?.message === "Days Already Full.")
                        toast.error("Os dias escolhidos atingiram a capacidade");
                    else if (createPersonResult?.response?.data?.message === "Already on these days.")
                        toast.error("CPF/Passaporte ja inscrito para os dias escolhidos");
                    else throw new Error("Error Inesperado");
                }
            }
        } catch (error) {
            toast.error(`Ocorreu um erro. ${JSON.stringify(error)}\nEntre em contato com a organização`);
        }
    };

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                const response = await EventApi.getEvent(eventId);
                if (response.data.data) {
                    const responseData = response.data.data;
                    setIsDay1Full(responseData?.day_1_counter && responseData?.day_1_counter >= config.DAILY_CAPACITY);
                    setIsDay2Full(responseData?.day_2_counter && responseData?.day_2_counter >= config.DAILY_CAPACITY);
                    setIsDay3Full(responseData?.day_3_counter && responseData?.day_3_counter >= config.DAILY_CAPACITY);
                    setIsFull(
                        responseData?.day_1_counter &&
                            responseData?.day_1_counter >= config.DAILY_CAPACITY &&
                            responseData?.day_2_counter &&
                            responseData?.day_2_counter >= config.DAILY_CAPACITY &&
                            responseData?.day_3_counter &&
                            responseData?.day_3_counter >= config.DAILY_CAPACITY
                    );
                    setEventData(responseData);
                } else throw new Error("Erro ao carregar evento");
            } catch (error) {
                console.error("Error fetching event data:", error);
                toast.error("Ocorreu um erro ao carregar informações do evento\nTente novamente mais tarde");
            }
        };

        fetchEventData();
    }, []);

    useEffect(() => {
        setPersonData(defaultForm);
        setFormSubmited(false);
        setSelectedGenders([]);
        setCustomGender("");
        setConfirmEmail("");
    }, [formSubmited]);

    const subscriptionForm = (
        <FormContainer>
            <TextField
                key="name"
                name="name"
                label="Digite seu nome completo"
                required
                fullWidth
                value={personData.name}
                onChange={onChange}
                disabled={isFull}
            />

            <TextField
                key="cpf"
                name="cpf"
                label="CPF ou Passaporte"
                required
                fullWidth
                value={personData.cpf}
                onChange={onChange}
                disabled={isFull}
            />
            <TextField
                key="email"
                name="email"
                label="Digite seu email"
                required
                fullWidth
                value={personData.email}
                onChange={onChange}
                disabled={isFull}
                type="email"
            />
            <TextField
                key="confirm_email"
                name="confirm_email"
                label="Confirme seu email"
                required
                fullWidth
                value={confirmEmail}
                onChange={(e) => {
                    e.preventDefault();
                    setConfirmEmail(e.target.value);
                }}
                error={confirmEmail !== personData.email}
                disabled={isFull}
                type="email"
                onPaste={(e) => {
                    e.preventDefault();
                    return false;
                }}
            />
            <InputMask
                mask="+55 (99) 9 9999-9999"
                value={personData.phone}
                onChange={onChange}
                maskChar=""
                type="text"
                name="phone"
                required
                disabled={isFull}
            >
                {() => (
                    <TextField
                        key="phone"
                        name="phone"
                        label="Digite um telefone para contato"
                        fullWidth
                        value={personData.phone}
                        onChange={onChange}
                        required
                    />
                )}
            </InputMask>

            <CheckboxContainer>
                <label className="label">
                    <h2>Gênero</h2>
                </label>
                <CheckboxLabelAlt>
                    <StyledInput
                        type="checkbox"
                        name="gender"
                        value="male"
                        checked={selectedGenders?.includes("male")}
                        onChange={handleGenderChange}
                        disabled={isFull}
                    />{" "}
                    Homem
                </CheckboxLabelAlt>
                <CheckboxLabelAlt>
                    <StyledInput
                        type="checkbox"
                        name="gender"
                        value="female"
                        checked={selectedGenders?.includes("female")}
                        onChange={handleGenderChange}
                        disabled={isFull}
                    />{" "}
                    Mulher
                </CheckboxLabelAlt>
                <CheckboxLabelAlt>
                    <StyledInput
                        type="checkbox"
                        name="gender"
                        value="nonbinary"
                        checked={selectedGenders?.includes("nonbinary")}
                        onChange={handleGenderChange}
                        disabled={isFull}
                    />{" "}
                    Não-Binário
                </CheckboxLabelAlt>
                <CheckboxLabelAlt>
                    <StyledInput
                        type="checkbox"
                        name="gender"
                        value="notsaid"
                        checked={selectedGenders?.includes("notsaid")}
                        onChange={handleGenderChange}
                        disabled={isFull}
                    />{" "}
                    Prefiro não dizer
                </CheckboxLabelAlt>
                <CheckboxLabelAlt>
                    <StyledInput
                        type="checkbox"
                        name="gender"
                        value="custom"
                        checked={selectedGenders?.includes("custom")}
                        onChange={handleGenderChange}
                        disabled={isFull}
                    />{" "}
                    Deixe-me digitar
                </CheckboxLabelAlt>
                {selectedGenders?.includes("custom") && (
                    <TextField
                        type="text"
                        name="customGender"
                        fullWidth
                        placeholder="Gênero"
                        value={personData.customGender}
                        onChange={handleCustomGenderChange}
                        required
                        disabled={isFull}
                    />
                )}
            </CheckboxContainer>

            <CheckboxContainer>
                <label className="label">
                    <h2>Escolha o(s) dia(s) que deseja ir</h2>
                </label>
                {!isDay1Full && (
                    <CheckboxLabelAlt>
                        <StyledInput
                            type="checkbox"
                            name="day_1"
                            checked={personData.day_1}
                            onChange={handleDaysChange}
                        />{" "}
                        17/05
                    </CheckboxLabelAlt>
                )}
                {!isDay2Full && (
                    <CheckboxLabelAlt>
                        <StyledInput
                            type="checkbox"
                            name="day_2"
                            checked={personData.day_2}
                            onChange={handleDaysChange}
                        />{" "}
                        18/05
                    </CheckboxLabelAlt>
                )}
                {!isDay3Full && (
                    <CheckboxLabelAlt>
                        <StyledInput
                            type="checkbox"
                            name="day_3"
                            checked={personData.day_3}
                            onChange={handleDaysChange}
                        />{" "}
                        19/05
                    </CheckboxLabelAlt>
                )}
            </CheckboxContainer>

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <KeyboardDatePicker
                    maxDate={new Date()}
                    variant="inline"
                    format="dd-MM-yyyy"
                    margin="normal"
                    name="birth"
                    label="Data de nascimento"
                    value={personData.birth}
                    onChange={handleChangeDate}
                    fullWidth
                    disableFuture
                    KeyboardButtonProps={{
                        "aria-label": "change date",
                    }}
                    disabled={isFull}
                />
            </MuiPickersUtilsProvider>

            <div style={{ display: "flex", margin: "10px 0", gap: "2px" }}>
                <Button
                    size="nano"
                    color="purple"
                    format="solid"
                    width="50%"
                    onClick={handleOpenAddChild}
                    disabled={isFull}
                >
                    Adicionar Criança
                </Button>
                <Button
                    size="nano"
                    color="green"
                    format="solid"
                    width="50%"
                    onClick={handleSubscribe}
                    disabled={isFull}
                >
                    Inscrever
                </Button>
            </div>

            {/* <Button
              size='nano'
              color='green'
              format='solid'
              width='100%'
              margin='20px 0'
              onClick={handleSubscribe}
              disabled={isFull}
          >Inscrever</Button> */}

            <TermsField>
                <div>
                    <input
                        type="checkbox"
                        checked={acceptedTerms}
                        onChange={(e) => {
                            setAcceptedTerms(e.target.checked);
                            if (!e.target.checked)
                                toast.warn("É necessário aceitar os termos de uso de dados e imagens");
                        }}
                    />
                    <p>
                        Declaro que concordo com os{" "}
                        <span onClick={() => handleClickOpen(true)}>
                            Termos de Uso de dados e imagem e Política de Privacidade
                        </span>
                    </p>
                </div>
            </TermsField>

            <Dialog open={isAddChildOpen} onClose={handleCloseAddChild} fullWidth maxWidth="md">
                <DialogContent>
                    <AddChildren
                        children={children}
                        handleAdd={handleAddChildren}
                        handleRemove={handleRemoveChildren}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        size="nano"
                        color="dark"
                        format="solid"
                        width="100%"
                        margin="20px 0"
                        onClick={handleCloseAddChild}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                <DialogContent>
                    <Terms />
                </DialogContent>
                <DialogActions>
                    <Button size="nano" color="dark" format="solid" width="100%" margin="20px 0" onClick={handleClose}>
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </FormContainer>
    );

    return (
        <Container>
            {/* <MetaPixel /> */}
            <Section>
                <a href="#subscribe_form" className="float">
                    <button className="float-button">INSCREVA-SE</button>
                </a>
            </Section>
            <Section id="subscribe_form">{subscriptionForm}</Section>
            <div className="cover"></div>
        </Container>
    );
};

export default SubscribeFullPage;
